module.exports = __webpack_public_path__ + "static/media/PM144.83f1d7c2.png";